import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { formatDuration, isNumeric } from './utils';

const Time = ({
  seconds,
  className,
}) => (
  <time dateTime={`PT${Math.round(seconds)}S`} className={className}>
    {formatDuration(seconds)}
  </time>
);

Time.propTypes = {
  className: PropTypes.string,
  seconds: PropTypes.number.isRequired,
};

// istanbul ignore next
const Duration = ({
  videoDuration,
  played,
}) => (
  <Fragment>
    {isNumeric(videoDuration) && isNumeric(played) &&
      <div className="video-player__controls-time">
        <Time seconds={videoDuration * played} /> | <Time seconds={videoDuration} />
      </div>
    }
  </Fragment>
);

Duration.propTypes = {
  videoDuration: PropTypes.number,
  played: PropTypes.number,
};

export default Duration;
